import {  postApiCall } from "../utils/request";
import { returnErrors } from "./errorAction";
import {
    GET_QUESTIONS, GET_QUESTION, CLOSED_TEST, GET_TEST_ANSWERS, GET_SCORE, GET_IMAGE_UPLOAD
} from '../actionType/type';

export const openQuiz = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/test/start`, obj);
        if (response.data.success) {
            dispatch({ type: GET_QUESTIONS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data.message, response?.status);
        }

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getQuestions = (ques) => async (dispatch) => {
    dispatch({
        type: GET_QUESTION,
        payload: ques
    });
}

export const selectAnswer = (qId, aId) => async (dispatch) => {
    dispatch({ type: GET_TEST_ANSWERS, payload: { aId, qId } });
}

export const closeQuiz1 = () => async (dispatch) => {
    return dispatch({ type: CLOSED_TEST });
}

export const getScore = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/test/result`, obj);
        dispatch({ type: GET_SCORE, payload: response.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const uploadImage = (file) => async (dispatch) => {
    let obj = new FormData()
    obj.append('image', file)
    try {
        const response = await postApiCall(`user/test/image`, obj);
        dispatch({ type: GET_IMAGE_UPLOAD, payload: response.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}



